module.exports = "/images/homeowner2.png?2d4332c1f720c6eea0a245053068f901";